import { React, useContext } from "react";

import ThemeContext from "../../lib/theme-context";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import Tooltip from "@mui/material/Tooltip";
import AccountManagement from "../../pages/account-management/index";


const Settings = ({ open, onClose }) => {
  const theme = useContext(ThemeContext);

  const goBack = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ maxWidth: "1920px", margin: "0 auto" }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#f9fafb",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Navbar Header */}
        <AppBar
          position="static"
          sx={{
            backgroundColor: theme[0] === "dark" ? "#25262b" : "#ffffff",
            borderBottom: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
            boxShadow: "none",
            zIndex: 1400,
          }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <PersonOutlineIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.3rem"
                }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  letterSpacing: "2px",
                  fontSize: "0.85em",
                  fontWeight: 500,
                  textTransform: "uppercase",
                }}
              >
                Account Management
              </Typography>
            </Box>
            <Tooltip title="Close">
              <IconButton
                onClick={goBack}
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>

        {/* Content Area */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#f9fafb",
          }}
        >
          <AccountManagement onClose={onClose} />
        </Box>
      </Box>
    </Modal>
  );
};

export default Settings;
